import {
  Card,
  CardHeader,
  CardBody,
  CardText,
  Collapse,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import { CommittedLoadConnection, CommittedLoadStatus } from "../../model/viewModel/committedLoad";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faThumbsUp, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { getDateDisplayText, getStatusDisplayText } from "../../utils/committedLoadFunctions";

export interface CommittedLoadConnectionWarningProps {
  connection: CommittedLoadConnection;
}

const CommittedLoadConnectionWarning = ({ connection }: CommittedLoadConnectionWarningProps) => {
  const [open, setOpen] = useState(false);

  const getStatusIcon = (status: CommittedLoadStatus) => {
    switch (status) {
      case CommittedLoadStatus.AcceptedNotYetConnected:
        return faThumbsUp;
      case CommittedLoadStatus.QuotationSent:
        return faPaperPlane;
      default:
        return faQuestion;
    }
  };

  const getDateLabelText = (status: CommittedLoadStatus) => {
    switch (status) {
      case CommittedLoadStatus.AcceptedNotYetConnected:
        return "Accepted Date";
      case CommittedLoadStatus.QuotationSent:
        return "Quotation Date";
      default:
        return "Date";
    }
  };

  const getChevronIcon = (open: boolean) => `icon-chevron-${open ? "down" : "right"}`;

  type DataItemProps = {
    label: string;
    value: string | number;
  };

  const DataItem = ({ label, value }: DataItemProps) => (
    <>
      <span className="font-weight-bolder">{label}:</span> {value}
    </>
  );

  const statusIconColId = `status-icon-col-${connection.enquiryReference}`;

  return (
    <Card className="border-warning bg-dark mb-2">
      <CardHeader onClick={() => setOpen(!open)} role="button">
        <Row className="align-items-center">
          <Col xs="1">
            <span className={getChevronIcon(open)}></span>
          </Col>
          <Col xs="1" id={statusIconColId}>
            <FontAwesomeIcon icon={getStatusIcon(connection.status)} />
            <UncontrolledTooltip target={statusIconColId}>
              {getStatusDisplayText(connection.status)}
            </UncontrolledTooltip>
          </Col>
          {open && (
            <Col>
              <span>Committed Load Warning</span>
            </Col>
          )}
          {!open && (
            <Col className="d-flex justify-content-between">
              <div>
                <span className="font-weight-bolder">Enquiry Ref:</span>{" "}
                {connection.enquiryReference}
              </div>
              <div>{getDateDisplayText(connection.date)}</div>
            </Col>
          )}
        </Row>
      </CardHeader>
      <Collapse isOpen={open}>
        <CardBody>
          <CardText
            style={{
              lineHeight: "2",
            }}
          >
            <DataItem label="Enquiry Ref" value={connection.enquiryReference} />
            <br />
            <DataItem
              label={getDateLabelText(connection.status)}
              value={getDateDisplayText(connection.date)}
            />
            <br />
            <DataItem label="Import Capacity kVA" value={connection.importCapacitykVa} />
            <br />
            <DataItem label="Export Capacity kW" value={connection.exportCapacitykW} />
            <br />
            <DataItem label="Status" value={getStatusDisplayText(connection.status)} />
          </CardText>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default CommittedLoadConnectionWarning;
